import React from 'react';
import CanvasView from './CanvasView';
import TaskDetails from './TaskDetails';
import EmailDetails from './EmailDetails';
import LexChat from './LexChat';
import PersonDetails from './PersonDetails';
import OpportunityDetails from './OpportunityDetails';
import FileDetails from './FileDetails';
import ClientsList from './ClientsList';
import DealKanbanBoard from './DealKanbanBoard';
import { useGlobalCanvas } from '../contexts/GlobalCanvasContext';

interface ContentRendererProps {
  tab: any;
  onUpdateTask?: () => void;
  onUpdateEmail?: () => void;
}

const ContentRenderer: React.FC<ContentRendererProps> = ({
  tab,
  onUpdateTask,
  onUpdateEmail
}) => {
  const { openPerson } = useGlobalCanvas();

  if (!tab) {
    return (
      <div className="empty-canvas">
        <span className="material-symbols-outlined">tab</span>
        <h3>No Tab Selected</h3>
        <p>Open a client, deal, task, or email from the sidebar</p>
        <p className="hint">Or double-click a category to see all items</p>
      </div>
    );
  }

  const handleTaskUpdate = async (taskId: string, updates: any) => {
    console.log('Task updated:', taskId, updates);
    onUpdateTask?.();
  };

  const handleTaskDelete = async (taskId: string) => {
    console.log('Task deleted:', taskId);
    onUpdateTask?.();
  };

  const handleEmailReply = async (reply: any) => {
    console.log('Email reply sent:', reply);
    onUpdateEmail?.();
  };

  const handleEmailClose = () => {
    console.log('Email details closed');
  };

  // Render content based on tab type
  switch (tab.type) {
    case 'canvas':
      return <CanvasView content={tab.content} />;

    case 'task':
      return (
        <TaskDetails
          task={tab.content}
          onUpdateTask={handleTaskUpdate}
          onDeleteTask={handleTaskDelete}
        />
      );

    case 'email':
      return (
        <EmailDetails
          email={tab.content}
          onSendReply={handleEmailReply}
          onClose={handleEmailClose}
        />
      );

    case 'chat':
      return <LexChat fullScreen={false} />;

    case 'person':
      return <PersonDetails person={tab.content} />;

    case 'opportunity':
      return <OpportunityDetails opportunity={tab.content} title={tab.title} />;

    case 'file':
      return <FileDetails file={tab.content} />;

    case 'document':
      return (
        <div className="empty-canvas">
          <span className="material-symbols-outlined">description</span>
          <h3>Document Viewer</h3>
          <p>Document viewing functionality coming soon</p>
        </div>
      );

    case 'clients-list':
      return <ClientsList onClientSelect={openPerson} />;

    case 'deals-list':
      return <DealKanbanBoard />;

    case 'tasks-list':
    case 'emails-list':
      return (
        <div className="empty-canvas">
          <span className="material-symbols-outlined">inbox</span>
          <h3>List View</h3>
          <p>List view coming soon</p>
        </div>
      );

    default:
      return (
        <div className="obsidian-content-area">
          <div style={{ padding: '2rem' }}>
            <h3 className="obsidian-content-title">{tab.title}</h3>
            <p className="obsidian-content-description">Content type: {tab.type}</p>
            {tab.content && (
              <pre className="obsidian-content-debug">
                {JSON.stringify(tab.content, null, 2)}
              </pre>
            )}
          </div>
        </div>
      );
  }
};

export default ContentRenderer;
